import BaseProxy from './BaseProxy';

class Topic extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/topic', parameters);
    }

    async getTopic(id = null) {
        return this.submit('get', `/get/user/topic/${id}`);
    }

    async startTopic(id = null) {
        return this.submit('post', `/start/${id}`);
    }

    async saveTopicTime(id = null, params = null) {
        return this.submit('post', `/save/time/${id}`, params);
    }

    async finishTopic(id = null) {
        return this.submit('post', `/finish/${id}`);
    }
}

export default Topic;



// WEBPACK FOOTER //
// ./src/api/Topic.js